export const ExportContactModal: string = 'ExportContactModal';
